import { EnvironmentProviders, Provider } from '@angular/core';
import { abiosConfigName } from '@bcf-v2-configurators/tokens/abios/lvbet/abios-config-name';
import { ABIOS_CONFIG_NAME } from '@bcf-v2-configurators/tokens/abios/token';
import { campaignIdsWithExpirationDate } from '@bcf-v2-configurators/tokens/affiliate/lvbetlv/affiliate-ids-with-expiration-date';
import { CAMPAIGN_IDS_WITH_EXPIRATION_DATE } from '@bcf-v2-configurators/tokens/affiliate/token';
import { APP_COUNTRY_BLOCKED_SUPPORT_EMAIL } from '@bcf-v2-configurators/tokens/app-country-blocker/token';
import { applePayByPiqPaymentMethodEnabled } from '@bcf-v2-configurators/tokens/applepay/lvbetlv/applepay-by-piq-enabled';
import { APPLEPAY_BY_PIQ_PAYMENT_METHOD_ENABLED } from '@bcf-v2-configurators/tokens/applepay/token';
import { payoutDetailsEnabled } from '@bcf-v2-configurators/tokens/betslip/lvbetlv/payout-details-enabled';
import {
  PAYOUT_DETAILS_ENABLED,
  QUICK_APPLEPAY_PIQ_IN_BETSLIP_ENABLED,
  QUICK_GOOGLEPAY_PIQ_IN_BETSLIP_ENABLED
} from '@bcf-v2-configurators/tokens/betslip/token';
import { bonusesEnabled } from '@bcf-v2-configurators/tokens/bonuses/lvbetlv/bonuses-enabled';
import { BONUSES_ENABLED } from '@bcf-v2-configurators/tokens/bonuses/token';
import { casinoLink, liveCasinoLink } from '@bcf-v2-configurators/tokens/casino-links/lvbetlv/casino-links';
import { CASINO_FULL_URL, LIVE_CASINO_FULL_URL } from '@bcf-v2-configurators/tokens/casino-links/token';
import { gamesImagesAssetsUrl } from '@bcf-v2-configurators/tokens/casino/lvbetlv/games-images-assets-url';
import { GAMES_IMAGES_ASSETS_URL } from '@bcf-v2-configurators/tokens/casino/token';
import { COOKIE_CONSENT_GAMBLING_ADULT_LOADER } from '@bcf-v2-configurators/tokens/cookie-consent/token';
import { dateFnsI18n } from '@bcf-v2-configurators/tokens/date-fns-i18n/lvbetlv/date-fns-i18n';
import { DATE_FNS_I18N } from '@bcf-v2-configurators/tokens/date-fns-i18n/token';
import { USER_PANEL_DISPLAY_TIME_IN_LOCAL_TIME_ZONE } from '@bcf-v2-configurators/tokens/date-format/token';
import { defaultLang } from '@bcf-v2-configurators/tokens/default-lang/lvbetlv/default-lang';
import { DEFAULT_LANG } from '@bcf-v2-configurators/tokens/default-lang/token';
import { I18N_OPTIMOVE_DESC_LOADER } from '@bcf-v2-configurators/tokens/descs-optimove-i18n/token';
import { I18N_DESC_LOADER } from '@bcf-v2-configurators/tokens/descs/token';
import { editProfileAddressAvailableFieldsFn } from '@bcf-v2-configurators/tokens/edit-profile/lvbetcom/edit-profile-available-fields';
import { editProfileShowBankAccountInfo } from '@bcf-v2-configurators/tokens/edit-profile/lvbetpl/edit-profile-show-bank-account-info';
import {
  EDIT_PROFILE_ADDRESS_AVAILABLE_FIELDS,
  EDIT_PROFILE_SHOW_BANK_ACCOUNT_INFO
} from '@bcf-v2-configurators/tokens/edit-profile/token';
import { footerBrandName } from '@bcf-v2-configurators/tokens/footer/lvbetlv/footer-brand-name';
import { footerLinksFn } from '@bcf-v2-configurators/tokens/footer/lvbetlv/footer-links';
import { spSidebarLinksFn } from '@bcf-v2-configurators/tokens/footer/lvbetlv/sp-sidebar-links';
import { FOOTER_BRAND_NAME, FOOTER_LINKS, SP_SIDEBAR_LINKS } from '@bcf-v2-configurators/tokens/footer/token';
import { imgWebConfig } from '@bcf-v2-configurators/tokens/img-webp/lvbetlv/img-web-config';
import { IMG_WEB_CONFIG } from '@bcf-v2-configurators/tokens/img-webp/token';
import { introBonusesTabHighlighted } from '@bcf-v2-configurators/tokens/intro/lvbetlv/intro-bonuses-tab-highlighted';
import { introHasCasinoComponents } from '@bcf-v2-configurators/tokens/intro/lvbetlv/intro-has-casino-components';
import { INTRO_BONUSES_TAB_HIGHLIGHTED, INTRO_HAS_CASINO_COMPONENTS } from '@bcf-v2-configurators/tokens/intro/token';
import { ladeskChatAdditionalConfig } from '@bcf-v2-configurators/tokens/ladesk-chat/lvbetlv/ladesk-chat-additional-config';
import { LADESK_CHAT_ADDITIONAL_CONFIG } from '@bcf-v2-configurators/tokens/ladesk-chat/token';
import { lvbetcomLanguageSwitcherFlagMap } from '@bcf-v2-configurators/tokens/language-switcher/lvbetcom/lvbetcom-language-switcher-flag-map';
import { LANGUAGE_SWITCHER_FLAG_MAP } from '@bcf-v2-configurators/tokens/language-switcher/token';
import { lotteryBrandName } from '@bcf-v2-configurators/tokens/lottery/lvbet/lottery-brand-name';
import { LOTTERY_BRAND_NAME } from '@bcf-v2-configurators/tokens/lottery/token';
import { lvWheelConfig } from '@bcf-v2-configurators/tokens/lv-wheel/lvbetlv/lv-wheel-config';
import { lotteryAssetsUrlValue } from '@bcf-v2-configurators/tokens/lv-wheel/lvbetpl/lottery-assets-url';
import { LV_WHEEL_CONFIG } from '@bcf-v2-configurators/tokens/lv-wheel/token';
import { lvisionBetBoosterApiKeys } from '@bcf-v2-configurators/tokens/lvision-bet-booster/lvbetlv/lvision-bet-booster-api-keys';
import { LVISION_BET_BOOSTER_API_KEYS } from '@bcf-v2-configurators/tokens/lvision-bet-booster/token';
import { mobileApplicationAppConfig } from '@bcf-v2-configurators/tokens/mobile-application/sportsbook/lvbetlv/config';
import { MOBILE_APPLICATION_APPS_CONFIG } from '@bcf-v2-configurators/tokens/mobile-application/token';
import { modalCookiesShowIndicator } from '@bcf-v2-configurators/tokens/modals/lvbetcom/modal-cookies-show-indicator';
import { modalCookiesConsentMode } from '@bcf-v2-configurators/tokens/modals/lvbetlv/modal-cookies-consent-mode';
import { modalNewTermsMode } from '@bcf-v2-configurators/tokens/modals/lvbetlv/modal-new-terms-mode';
import {
  MODAL_COOKIES_CONSENT_MODE,
  MODAL_COOKIES_INDICATOR,
  MODAL_NEW_TERMS_MODE
} from '@bcf-v2-configurators/tokens/modals/token';
import { COMMISSION_ENABLED } from '@bcf-v2-configurators/tokens/my-bets/token';
import { OPTIMOVE_SDK_CONFIG_LOADER } from '@bcf-v2-configurators/tokens/optimove-sdk/tokens';
import { piqStyles } from '@bcf-v2-configurators/tokens/piq-styles/lvbetlv/piq-styles';
import { piqTheme } from '@bcf-v2-configurators/tokens/piq-styles/lvbetlv/piq-theme';
import { PIQ_CSS, PIQ_THEME } from '@bcf-v2-configurators/tokens/piq-styles/token';
import { PUSH_NOTIFICATIONS_CONFIG_LOADER } from '@bcf-v2-configurators/tokens/push-notifications/token';
import { rgLimitsNonParallelPredefinedAmounts } from '@bcf-v2-configurators/tokens/rg-limits-parallel/lvbetlv/rg-limits-non-parallel-predefined-amounts';
import { RG_LIMITS_NON_PARALLEL_PREDEFINED_AMOUNTS } from '@bcf-v2-configurators/tokens/rg-limits-parallel/token';
import { LOGIN_SMART_ID_ENABLED } from '@bcf-v2-configurators/tokens/smart-id/token';
import { sportsImagesAssetsUrl } from '@bcf-v2-configurators/tokens/sports/lvbetlv/sports-images-assets-url';
import { SPORTS_IMAGES_ASSETS_URL } from '@bcf-v2-configurators/tokens/sports/token';
import { statscoreVizuConfig } from '@bcf-v2-configurators/tokens/statscore-vizu-config/lvbet/statscore-vizu-config';
import { STATSCORE_VIZU_CONFIG } from '@bcf-v2-configurators/tokens/statscore-vizu-config/token';
import { provideVanillaTsTokens } from '@bcf-v2-shared/misc/vanilla-ts-providers/provide-vanilla-ts-tokens';
import { logRocketApiKey } from '@bcf-vanilla-ts-v1-configurators/tokens/log-rocket/lvbetlv/log-rocket-api-key';
import { registerLogRocketApiKey } from '@bcf-vanilla-ts-v1-configurators/tokens/log-rocket/token';
import { LOTTERY_ASSETS_URL } from '@bcf-vanilla-ts-v1-configurators/tokens/lottery/token';

export const settingsProviders: (Provider | EnvironmentProviders)[] = [
  {
    provide: IMG_WEB_CONFIG,
    useValue: imgWebConfig
  },
  {
    provide: DEFAULT_LANG,
    useValue: defaultLang
  },
  {
    provide: I18N_DESC_LOADER,
    useValue: () =>
      import(
        /* webpackChunkName: "const-i18n-desc" */ '@bcf-v2-configurators/tokens/descs/lvbetlv/mobile-web/i18n-descs'
        // eslint-disable-next-line @typescript-eslint/typedef
      ).then((mod) => mod.i18nDesc)
  },
  {
    provide: GAMES_IMAGES_ASSETS_URL,
    useValue: gamesImagesAssetsUrl
  },
  {
    provide: LOGIN_SMART_ID_ENABLED,
    useValue: true
  },
  {
    provide: EDIT_PROFILE_ADDRESS_AVAILABLE_FIELDS,
    useValue: editProfileAddressAvailableFieldsFn
  },
  {
    provide: EDIT_PROFILE_SHOW_BANK_ACCOUNT_INFO,
    useValue: editProfileShowBankAccountInfo
  },
  {
    provide: LADESK_CHAT_ADDITIONAL_CONFIG,
    useValue: ladeskChatAdditionalConfig
  },
  {
    provide: LANGUAGE_SWITCHER_FLAG_MAP,
    useValue: lvbetcomLanguageSwitcherFlagMap
  },
  {
    provide: STATSCORE_VIZU_CONFIG,
    useValue: statscoreVizuConfig
  },
  {
    provide: ABIOS_CONFIG_NAME,
    useValue: abiosConfigName
  },
  {
    provide: CASINO_FULL_URL,
    useValue: casinoLink
  },
  {
    provide: LIVE_CASINO_FULL_URL,
    useValue: liveCasinoLink
  },
  {
    provide: BONUSES_ENABLED,
    useValue: bonusesEnabled
  },
  {
    provide: FOOTER_LINKS,
    useValue: footerLinksFn
  },
  {
    provide: SP_SIDEBAR_LINKS,
    useValue: spSidebarLinksFn
  },
  {
    provide: FOOTER_BRAND_NAME,
    useValue: footerBrandName
  },
  {
    provide: MOBILE_APPLICATION_APPS_CONFIG,
    useValue: mobileApplicationAppConfig
  },
  {
    provide: PUSH_NOTIFICATIONS_CONFIG_LOADER,
    useValue: () =>
      import('@bcf-v2-configurators/tokens/push-notifications/lvbetlv/push-notifications-config').then(
        // eslint-disable-next-line @typescript-eslint/typedef
        (mod) => mod.pushNotificationsConfigs
      )
  },
  {
    provide: OPTIMOVE_SDK_CONFIG_LOADER,
    useValue: () =>
      import('@bcf-v2-configurators/tokens/optimove-sdk/lvbetlv/sportsbook/mobile-web/optimove-sdk-config').then(
        // eslint-disable-next-line @typescript-eslint/typedef
        (mod) => mod.optimoveSdkConfigs
      )
  },
  {
    provide: I18N_OPTIMOVE_DESC_LOADER,
    useValue: () =>
      import('@bcf-v2-configurators/tokens/descs-optimove-i18n/lvbetlv/sportsbook/i18n-optimove-desc').then(
        // eslint-disable-next-line @typescript-eslint/typedef
        (mod) => mod.i18nOptimoveDesc
      )
  },
  {
    provide: LVISION_BET_BOOSTER_API_KEYS,
    useValue: lvisionBetBoosterApiKeys
  },
  {
    provide: RG_LIMITS_NON_PARALLEL_PREDEFINED_AMOUNTS,
    useValue: rgLimitsNonParallelPredefinedAmounts
  },
  {
    provide: PAYOUT_DETAILS_ENABLED,
    useValue: payoutDetailsEnabled
  },
  {
    provide: LV_WHEEL_CONFIG,
    useValue: lvWheelConfig
  },
  {
    provide: LOTTERY_ASSETS_URL,
    useValue: lotteryAssetsUrlValue
  },
  {
    provide: CAMPAIGN_IDS_WITH_EXPIRATION_DATE,
    useValue: campaignIdsWithExpirationDate
  },
  {
    provide: USER_PANEL_DISPLAY_TIME_IN_LOCAL_TIME_ZONE,
    useValue: true
  },
  {
    provide: MODAL_NEW_TERMS_MODE,
    useValue: modalNewTermsMode
  },
  {
    provide: MODAL_COOKIES_INDICATOR,
    useValue: modalCookiesShowIndicator
  },
  {
    provide: MODAL_COOKIES_CONSENT_MODE,
    useValue: modalCookiesConsentMode
  },
  {
    provide: COOKIE_CONSENT_GAMBLING_ADULT_LOADER,
    useValue: () =>
      import(
        /* webpackChunkName: "const-cookie-consent-gambling-adult" */ '@bcf-v2-configurators/tokens/cookie-consent/projects/sportsbook/lvbetlv/cookie-consent-gambling-adult'
        // eslint-disable-next-line @typescript-eslint/typedef
      ).then((mod) => mod.cookieConsentGamblingAdult)
  },
  { provide: PIQ_THEME, useValue: piqTheme },
  { provide: PIQ_CSS, useValue: piqStyles },
  {
    provide: DATE_FNS_I18N,
    useValue: dateFnsI18n
  },
  {
    provide: LOTTERY_BRAND_NAME,
    useValue: lotteryBrandName
  },
  provideVanillaTsTokens(() => {
    registerLogRocketApiKey(logRocketApiKey);
  }),
  {
    provide: COMMISSION_ENABLED,
    useValue: false
  },
  {
    provide: QUICK_APPLEPAY_PIQ_IN_BETSLIP_ENABLED,
    useValue: true
  },
  {
    provide: QUICK_GOOGLEPAY_PIQ_IN_BETSLIP_ENABLED,
    useValue: true
  },
  {
    provide: INTRO_HAS_CASINO_COMPONENTS,
    useValue: introHasCasinoComponents
  },
  {
    provide: INTRO_BONUSES_TAB_HIGHLIGHTED,
    useValue: introBonusesTabHighlighted
  },
  {
    provide: SPORTS_IMAGES_ASSETS_URL,
    useValue: sportsImagesAssetsUrl
  },
  {
    provide: APPLEPAY_BY_PIQ_PAYMENT_METHOD_ENABLED,
    useValue: applePayByPiqPaymentMethodEnabled
  },
  {
    provide: APP_COUNTRY_BLOCKED_SUPPORT_EMAIL,
    useValue: 'support@lvbet.lv'
  }
];
